/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Listingfp_Name1Inputs */

const en_resources_listingfp_name1 = /** @type {(inputs: Resources_Listingfp_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semi-Finished Works Listing`)
};

const fr_resources_listingfp_name1 = /** @type {(inputs: Resources_Listingfp_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Travaux Semi-finis`)
};

const es_resources_listingfp_name1 = /** @type {(inputs: Resources_Listingfp_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listado de Trabajos Semi-acabados`)
};

const de_resources_listingfp_name1 = /** @type {(inputs: Resources_Listingfp_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste halbfertige Arbeiten`)
};

const nl_resources_listingfp_name1 = /** @type {(inputs: Resources_Listingfp_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lijst halffabricaten`)
};

/**
* | output |
* | --- |
* | "Semi-Finished Works Listing" |
*
* @param {Resources_Listingfp_Name1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_listingfp_name1 = /** @type {((inputs?: Resources_Listingfp_Name1Inputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Listingfp_Name1Inputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_listingfp_name1(inputs)
	if (locale === "fr") return fr_resources_listingfp_name1(inputs)
	if (locale === "es") return es_resources_listingfp_name1(inputs)
	if (locale === "de") return de_resources_listingfp_name1(inputs)
	return nl_resources_listingfp_name1(inputs)
});
export { resources_listingfp_name1 as "resources.listingFp.name" }